/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_SelectedInputs */

const en_common_selected = /** @type {(inputs: Common_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selected`)
};

const fr_common_selected = /** @type {(inputs: Common_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionne`)
};

const de_common_selected = /** @type {(inputs: Common_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählt`)
};

const it_common_selected = /** @type {(inputs: Common_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selezionato`)
};

const ru_common_selected = /** @type {(inputs: Common_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Избранные`)
};

const es_common_selected = /** @type {(inputs: Common_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionado`)
};

const zh_cn2_common_selected = /** @type {(inputs: Common_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已选`)
};

const ja_common_selected = /** @type {(inputs: Common_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択済み`)
};

const hi_common_selected = /** @type {(inputs: Common_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित`)
};

const pt_pt2_common_selected = /** @type {(inputs: Common_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecionado`)
};

/**
* | output |
* | --- |
* | "Selected" |
*
* @param {Common_SelectedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const common_selected = /** @type {((inputs?: Common_SelectedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_SelectedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_common_selected(inputs)
	if (locale === "de") return de_common_selected(inputs)
	if (locale === "it") return it_common_selected(inputs)
	if (locale === "ru") return ru_common_selected(inputs)
	if (locale === "es") return es_common_selected(inputs)
	if (locale === "zh-CN") return zh_cn2_common_selected(inputs)
	if (locale === "ja") return ja_common_selected(inputs)
	if (locale === "hi") return hi_common_selected(inputs)
	if (locale === "pt-PT") return pt_pt2_common_selected(inputs)
	return en_common_selected(inputs)
});